<ng-container>
  <div class="modal-header">
    <h4 class="font-weight-bold mb-0">{{ planTitle }}</h4>
  </div>
  <div class="modal-body pt-0 plan-tasks-modal__body">
    <tabset>
      <tab
        (selectTab)="tabChange('tasks')"
        heading="{{ 'headers.routing.plan.tasks' | translate }}"
      >
        <div class="plan-tasks-modal__tab-content plan-tasks-modal__tab-content--tasks d-flex flex-column ag-grid-container">
          <app-plans-tasks
            [selectedPlan]="planId"
            [showReleasedVersionOnly]="showReleasedVersionOnly"
            class="d-flex flex-column h-100 w-100"
          ></app-plans-tasks>
        </div>
      </tab>
      <tab
        (selectTab)="tabChange('pmRouteData')"
        heading="{{ 'headers.routing.plan.pm_route.feedback' | translate }}"
      >
        <div class="plan-tasks-modal__tab-content d-flex flex-column">
          <app-pm-route-data
            *ngIf="activeTab === 'pmRouteData'"
            [planId]="planId"
            class="d-flex flex-column h-100 w-100"
          ></app-pm-route-data>
        </div>
      </tab>
    </tabset>
  </div>
  <div class="modal-footer justify-content-end">
    <button
      (click)="bsModalRef.hide()"
      class="btn btn-sm btn-light"
      type="button"
    >
      <i class="la la-ban"></i>
      {{ "navigations.cancel" | translate }}
    </button>
  </div>
</ng-container>
